import validate from '@/utils/validations/nisPisPasep'

export default {
    validate,
    message: 'O PIS / PASEP | NIS informado é inválido.',
}